import { Flex } from "@aws-amplify/ui-react";
import { HealthRecordsDocumentPreviewView } from "../../../../ui-components";
import { useState } from "react";
import { useNavigate } from "react-router-dom";

const MyMRIVideo1 = () => {
  return (
    <>
      <video width={650} controls>
        <source src="/videos/mri1.mov"></source>
      </video>
    </>
  );
};

const MyMRIVideo2 = () => {
  return (
    <>
      <video width={650} controls>
        <source src="/videos/mri2.mov"></source>
      </video>
    </>
  );
};
const MyMRIImage1 = () => {
  return (
    <>
      <img alt="preview-1" width={650} src="/images/mri-image1.jpg" />
    </>
  );
};

const MyMRIImage2 = () => {
  return (
    <>
      <img alt="preview-1" width={650} src="/images/mri-image2.jpg" />
    </>
  );
};

const MyMRIImage3 = () => {
  return (
    <>
      <img alt="preview-1" width={650} src="/images/mri-image3.jpg" />
    </>
  );
};

const MyMRIImage4 = () => {
  return (
    <>
      <img alt="preview-1" width={650} src="/images/mri-image4.jpg" />
    </>
  );
};

const HealthRecordsDocumentPreviewPage = () => {
  const [componetToShow, setComponetToShow] = useState(<MyMRIVideo1 />);
  const navigate = useNavigate();
  return (
    <Flex
      gap="24px"
      direction="column"
      width="unset"
      minWidth={650}
      height="unset"
      justifyContent="flex-start"
      alignItems="flex-start"
      position="relative"
      padding="32px 32px 32px 32px"
      backgroundColor="rgba(250,250,250,1)"
    >
      <HealthRecordsDocumentPreviewView
        overrides={{
          DocumentViewPlayerCard: {
            overrides: {
              dvcHeader: {
                children: "MRI (Magnetic Resonance Imaging)",
              },
              dvcAttachmentView40235085: {
                children: componetToShow,
              },
              dvcAttachmentTitle40235089: {
                onClick: () => {
                  setComponetToShow(<MyMRIVideo1 />);
                },
              },
              dvcAttachmentTitle40235092: {
                onClick: () => {
                  setComponetToShow(<MyMRIVideo2 />);
                },
              },
              dvcAttachmentTitle40235095: {
                onClick: () => {
                  setComponetToShow(<MyMRIImage1 />);
                },
              },
              dvcAttachmentTitle40235098: {
                onClick: () => {
                  setComponetToShow(<MyMRIImage2 />);
                },
              },
              dvcAttachmentTitle40235101: {
                onClick: () => {
                  setComponetToShow(<MyMRIImage3 />);
                },
              },
              dvcAttachmentTitle40235104: {
                onClick: () => {
                  setComponetToShow(<MyMRIImage4 />);
                },
              },
              dvcBackButton40235204: {
                onClick: () => navigate("/user/hr/documents"),
              },
              dvcBackButton40236773: {
                onClick: () => navigate("/user/hr/documents/mri"),
              },
            },
          },
        }}
      />
    </Flex>
  );
};

export default HealthRecordsDocumentPreviewPage;
